module.exports = __webpack_public_path__ + "img/symptomSurveyPainArea.88561757.jpg";